import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import ConsentListContext from './Context/ConsentContext';
import StepperContext from './Context/StepperContext';
import AuthApis from '../hepler/authApis.service';
import { toast } from 'react-toastify';
import RequestedConsents from './paymentConsent/RequestedConsents';
import { Box, Button, useMediaQuery, useTheme, Dialog } from '@mui/material';
import LinkedAccountsSection from './Accounts/LinkedAccountsSection';
// import ConsentCard from './paymentConsent/ConsentCard';
import ConsentCardFull from './paymentConsent/ConsentCardFull/ConsentCardFull';
import linkedAccountsSectionStyles from './Accounts/LinkedAccountsSection.styles';
import DialogBox from './Dialog Box/Dialog Box';
import WhyShare from './Sections/WhyShare';
import DenyConsent from './Accounts/DenyConsent';
import { areAllArraysEmptyForConsents } from '../hepler/functions';
import FloatingButton from './Fab/FloatingButton';
import Drawer from './Drawer/Drawer';
import FiuList from './paymentConsent/FiuList';
import LinkAccountsOtp from './Dialog Box/LinkAccountsOtp';
import {
	isAccountLinked,
	showSelectButton,
	filterAccountsByRestrictions,
	fipExclusionFilter,
  getUniqueKey
} from '../utils/helper.utils';
import { postMessage } from '../utils/common.utils';
import {
	filterLinkedAccountsByRestrictions,
	filterSelectedAccountsByRestrictions,
	areAllMandatoryRestrictionsSatisfied,
} from '../utils/targetedAccounts.utils';
import {
	startConsentView,
	captureConsentApproved,
	captureConsentDenied,
	captureConsentPageLoaded,
} from '../utils/analytics/posthog.utils';
import {
	computeAccountRestrictions,
	filterRestrictedAccounts,
	removeRestrictedAccountsFromSelection,
	isAccountRestrictedForConsent,
	calculateAccountBlockingMetrics,
} from '../utils/accountRestrictions.utils';
import { useTranslation } from '../hooks/useTranslation';

function PaymentConsent(props) {
	const { t } = useTranslation();
	const fipExclusionFromJourney = global?.sdkOptions?.fipExclusionFromJourney;
	const consentsContext = useContext(ConsentListContext);
	const { prevStep } = useContext(StepperContext);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const consentsAll = consentsContext.consentList;
	const consentsAccepted = consentsContext.acceptedConsentsMultiConsent;
	const consentsDenied = consentsContext.deniedConsentsMultiConsent;
	const [state, setState] = useState({
		linkedAccounts: [], // Filtered for display
		allLinkedAccounts: [], // Unfiltered for validation
		matchedRestrictions: [], // Only restrictions that were actually discovered
		selectedAccounts: [],
		consentDetailsList: consentsContext?.consentList,
		isDisable: false,
		consentSelectedAccounts: {},
		uniqueLinkedAccounts: [],
	});
	const [shouldProceedWithConsent, setShouldProceedWithConsent] =
		useState(false);
	const [showSelectAll, setShowSelectAll] = useState(true);
	const [selectAll, setSelectAll] = useState(
		consentsAll.length === consentsContext?.selectedConsents.length
	);
	const [openDrawer, setOpenDrawer] = useState(false);

	// State to track whether any info icon was clicked
	const [isPurposeIconClicked, setIsPurposeIconClicked] = useState(false);
	const [isAccountInfoIconClicked, setIsAccountInfoIconClicked] =
		useState(false);

	// State for account linking process
	const [linkingState, setLinkingState] = useState({
		isLinking: false,
		currentFipIndex: 0,
		fipsToLink: [],
		showLinkDialog: false,
	});

	// State to track if consent page loaded analytics has been fired
	const [hasConsentPageAnalyticsFired, setHasConsentPageAnalyticsFired] =
		useState(false);

	const handleInfoClick = (iconType) => {
		if (iconType === 'purpose') setIsPurposeIconClicked(true);
		if (iconType === 'accountInfo') setIsAccountInfoIconClicked(true);
	};

	// Function to calculate account blocking metrics and trigger analytics
	const triggerConsentPageAnalytics = (linkedAccounts) => {
		if (
			hasConsentPageAnalyticsFired ||
			!linkedAccounts ||
			linkedAccounts.length === 0
		) {
			return;
		}

		// Calculate analytics metrics using utility function
		const analyticsMetrics = calculateAccountBlockingMetrics(
			linkedAccounts,
			consentsAll
		);

		// Trigger analytics event
		captureConsentPageLoaded(analyticsMetrics);

		// Mark analytics as fired
		setHasConsentPageAnalyticsFired(true);
	};

	// console.log('State: ', state);
	const authApis = new AuthApis();
	const SUBMITTING_CONSENT_COUNTER =
		consentsAll.length > 1 && global.institutionType !== 'LSP' ? 1000 : 0;

	//New
	const getMatchingConsents = (consent, options) => {
		for (const option of options) {
			if (option['Purpose.code'] == consent?.Purpose?.code) {
				if (!option.checkbox || option.defaultCheck) {
					return consent?.ConsentHandle;
				}
			}
		}
		return '';
	};

	// Moved to targetedAccounts.utils.js

	const [selectedConsentsState, setSelectedConsentsState] = useState(
		consentsContext?.selectedConsents.map((a) => {
			if (
				consentsAll.length > 1 &&
				global.consentOptions &&
				global.institutionType !== 'LSP'
			) {
				return getMatchingConsents(a, global.consentOptions);
			}
			return a?.ConsentHandle;
		})
	);

	useEffect(() => {
		if (
			consentsAll.length > 1 &&
			global.consentOptions &&
			global.institutionType !== 'LSP'
		) {
			consentsContext.updateSelectedConsentList(
				consentsAll.filter((x) =>
					selectedConsentsState.includes(x.ConsentHandle)
				)
			);
			setShowSelectAll(showSelectButton(consentsAll, global.consentOptions));
		}
	}, [selectedConsentsState]);
	const [deny, setDeny] = useState(false);

	const isAcceptDisabled = useMemo(() => {
		const activeHandles = (selectedConsentsState || []).filter(Boolean);
		// Disable if no accounts selected for any active consent
		const noAccountsSelected =
			activeHandles.length === 0 ||
			areAllArraysEmptyForConsents(
				state.consentSelectedAccounts,
				activeHandles
			);
		if (noAccountsSelected) return true;

		// In multi-consent journeys, ensure mandatory consents have at least one account selected
		if (consentsAll.length > 1 && Array.isArray(global.consentOptions)) {
			const mandatoryPurposeCodes = new Set(
				global.consentOptions
					.filter((opt) => !opt.checkbox)
					.map((opt) => String(opt['Purpose.code']))
			);
			const mandatoryHandles = consentsAll
				.filter((c) => mandatoryPurposeCodes.has(String(c?.Purpose?.code)))
				.map((c) => c.ConsentHandle);

			const mandatoryActive = mandatoryHandles.filter((h) =>
				activeHandles.includes(h)
			);
			if (mandatoryActive.length > 0) {
				const hasMissing = mandatoryActive.some(
					(h) =>
						!Array.isArray(state.consentSelectedAccounts[h]) ||
						state.consentSelectedAccounts[h].length === 0
				);
				if (hasMissing) return true;
			}
		}
		return false;
	}, [selectedConsentsState, state.consentSelectedAccounts, consentsAll]);

	const handleClose = (event, reason) => {
		// if (reason && reason === 'backdropClick') {
		// 	return;
		// }
		setDeny(false);
	};
	// consent checkout page
	const selectUnselectConsents = (consent) => {
		setSelectedConsentsState((prevConsents) => {
			if (prevConsents.includes(consent)) {
				const index = prevConsents.indexOf(consent);
				prevConsents.splice(index, 1);
			} else {
				prevConsents.push(consent);
			}
			consentsContext.updateSelectedConsentList(
				consentsAll.filter((x) => prevConsents.includes(x.ConsentHandle))
			);
			if (prevConsents.length < consentsAll.length) {
				setSelectAll(false);
			} else {
				setSelectAll(true);
			}

			return [...prevConsents];
		});
	};

	useEffect(() => {
		// Start tracking consent view time when component mounts
		startConsentView();
		
		// Clear userClickedAddMore ONLY if in targeted account mode:
		// 1. No new discovery data (user clicked back)
		// 2. userClickedAddMore is set (user clicked "Add More")
		// 3. isAddAccount flag is set (user is in "Add Account" mode)
		
		// Only clear if user is in "Add Account" mode and came back without discovering
		// BUT: If user has already completed Add More flow once, keep showing all accounts
		if (global.redirectAccountRestrictions && !props?.location?.state?.data?.length && global.userClickedAddMore && global.isAddAccount) {
			// Check if user has completed Add More discovery at least once
			if (!global.hasCompletedAddMoreFlow) {
				// First time clicking Add More without completing - revert to restricted view
				delete global.userClickedAddMore;
				delete global.isAddAccount;
				global.isTargetedDiscoveryMode = true;
			} else {
				// User has already completed Add More flow before - keep showing all accounts
				delete global.isAddAccount; // Just clear the temporary flag
			}
		} else if (global.redirectAccountRestrictions && props?.location?.state?.data?.length && global.isAddAccount) {
			// User discovered accounts via Add More - mark flow as completed
			global.hasCompletedAddMoreFlow = true;
			delete global.isAddAccount;
		}

		// For isFlowChange, always fetch linked accounts from API to get proper RefNumber
		// Then merge with discovered accounts
		if (global.isFlowChange === 'true') {
			props.updateLoader(true);
			getLinkedAcc();
			return;
		}

		// Normal flow - process linked accounts from props
		const hasLinkedAccounts = props?.location?.state?.data?.length > 0;

		if (hasLinkedAccounts) {
			const data = props.location.state.data || [];
			const shouldFilter =
				!!fipExclusionFromJourney && fipExclusionFromJourney.length > 0;

			const filteredData = shouldFilter ? fipExclusionFilter(data) : data;
			const allAccounts = filteredData;
			
			// Extract matched restrictions from discovered accounts
			const matchedRestrictions = [];
			
			if (global.redirectAccountRestrictions) {
				filteredData.forEach(account => {
					// Try to find matching restriction by comparing last 4 digits
					const matchingRestriction = global.redirectAccountRestrictions.find(
						(restriction) => {
							const fipIdMatch = account.fipId === restriction.fipId;
							const fiTypeMatch = account.FIType === restriction.fiType;
							const accTypeMatch = account.accType === restriction.accType;
							// Compare last 4 digits: restriction might have just "6086" while account has "XXXXX6086"
							const maskedMatch = account.maskedAccNumber === restriction.maskedAccNumber || 
							                   account.maskedAccNumber?.slice(-4) === restriction.maskedAccNumber;
							return fipIdMatch && fiTypeMatch && accTypeMatch && maskedMatch;
						}
					);
					
					if (matchingRestriction) {
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: matchingRestriction.restrictions
						});
					} else if (account.restrictions) {
						// If account already has restrictions attached, use them
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: account.restrictions
						});
					}
				});
			}

			// Check if there are linked accounts but none match the provided AccType and FIType
			// Skip this redirect for isFlowChange when we have discovered accounts (even if empty)
			const shouldRedirectBack =
				global.isFlowChange !== 'true' &&
				((global?.accountRestrictions &&
					filterAccountsByRestrictions(allAccounts).length === 0) ||
					allAccounts.length === 0);

			if (shouldRedirectBack) {
				props.updateLoader(true);
				toast.error(t('paymentConsent.error.noRelevantAccLinked'));
				setTimeout(() => {
					props.history.push(
						`/home/?number=${global.mobileNumber}&isAddAccount=true&isNewUser=true`
					);
					props.updateLoader(false);
					prevStep();
				}, 0);
				return;
			}

			// Filter accounts to display based on restrictions
			const linkedAccountsToDisplay = (global.redirectAccountRestrictions && !global.userClickedAddMore)
				? filteredData.filter(acc => 
					global.redirectAccountRestrictions.some(restriction => {
						const fipIdMatch = acc.fipId === restriction.fipId;
						const fiTypeMatch = acc.FIType === restriction.fiType;
						const accTypeMatch = acc.accType === restriction.accType;
						const maskedMatch = acc.maskedAccNumber === restriction.maskedAccNumber || 
						                   acc.maskedAccNumber?.slice(-4) === restriction.maskedAccNumber;
						return fipIdMatch && fiTypeMatch && accTypeMatch && maskedMatch;
					})
				)
				: global?.accountRestrictions
				? filterAccountsByRestrictions(filteredData)
				: filteredData;
			
			// Set consent selections
			const consentSelections = setConsentSelectedAccount(linkedAccountsToDisplay);
			
			// Filter out restricted accounts from initial selection
			const accountsWithoutRestrictions = filterRestrictedAccounts(
				linkedAccountsToDisplay,
				consentsAll
			);
			
			// Initial selection
			const accountsForSelection = (global.redirectAccountRestrictions && !global.userClickedAddMore)
				? linkedAccountsToDisplay
				: global.manualAccCheck
				? []
				: global?.accountRestrictions
				? []
				: [...accountsWithoutRestrictions];
			
			setState((prevState) => ({
				...prevState,
				allLinkedAccounts: filteredData, // Unfiltered for validation
				matchedRestrictions, // Store only matched restrictions
				linkedAccounts: linkedAccountsToDisplay,
				selectedAccounts: accountsForSelection,
				consentSelectedAccounts: consentSelections,
			}));

			// Trigger analytics after accounts are loaded from state
			triggerConsentPageAnalytics(allAccounts);

			props.updateLoader(false);
		} else {
			props.updateLoader(true);
			getLinkedAcc();
		}
	}, []);

	useEffect(() => {
		const uniqueAccounts = [];
		const seenAccounts = new Set();

		state.linkedAccounts.forEach((account) => {
			const uniqueKey = getUniqueKey(account, account.fipId);
			if (!seenAccounts.has(uniqueKey)) {
				seenAccounts.add(uniqueKey);
				uniqueAccounts.push(account);
			}
		});

		setState((prevState) => ({
			...prevState,
			uniqueLinkedAccounts: uniqueAccounts,
		}));
	}, [state.linkedAccounts]);

	const setConsentSelectedAccount = (accounts) => {
		const res = {};
		for (const consent of consentsAll) {
			const restrictions = computeAccountRestrictions(consent, accounts);
			const restrictedAccountRefs = Object.keys(restrictions);

			const filteredAccounts = accounts.filter(
				(x) =>
					consent?.fiTypes.includes(x?.FIType) &&
					!restrictedAccountRefs.includes(x?.accRefNumber)
			);

		res[consent?.ConsentHandle] = global.redirectAccountRestrictions
			? [...(filteredAccounts || [])]
			: global.manualAccCheck
			? []
			: global?.accountRestrictions
			? []
			: [...(filteredAccounts || [])];
		}
		return res;
	};

	const getLinkedAcc = () => {
		authApis.getLinkedAccounts().then((res) => {
			props.updateLoader(false);
			if (res?.status === 'SUCCESS') {
				const shouldFilter =
					!!fipExclusionFromJourney && fipExclusionFromJourney.length > 0;
			const baseAccounts = global?.accountRestrictions
				? filterAccountsByRestrictions(res?.LinkedAccounts)
				: res?.LinkedAccounts;
			const filteredAccounts = shouldFilter
				? fipExclusionFilter(baseAccounts)
				: baseAccounts;
				
		// If redirectAccountRestrictions exists and user hasn't clicked "Add More", filter accounts
		let accountsToDisplay = (global.redirectAccountRestrictions && !global.userClickedAddMore)
			? filterLinkedAccountsByRestrictions(res?.LinkedAccounts)
			: filteredAccounts;

				// Extract matched restrictions from API response
				// API doesn't return restrictions, so manually match against global.redirectAccountRestrictions
				let matchedRestrictions = [];
			if (global.redirectAccountRestrictions) {
				filteredAccounts.forEach(account => {
					const matchingRestriction = global.redirectAccountRestrictions.find(
						(restriction) => {
							const fipIdMatch = account.fipId === restriction.fipId;
							const fiTypeMatch = account.FIType === restriction.fiType;
							const accTypeMatch = account.accType === restriction.accType;
							// Compare last 4 digits: restriction might have just "6086" while account has "XXXXX6086"
							const maskedMatch = account.maskedAccNumber === restriction.maskedAccNumber || 
							                   account.maskedAccNumber?.slice(-4) === restriction.maskedAccNumber;
							return fipIdMatch && fiTypeMatch && accTypeMatch && maskedMatch;
						}
					);
					
					if (matchingRestriction) {
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: matchingRestriction.restrictions
						});
					} else if (account.restrictions) {
						// If account already has restrictions attached, use them
						matchedRestrictions.push({
							fipId: account.fipId,
							fiType: account.FIType,
							accType: account.accType,
							maskedAccNumber: account.maskedAccNumber,
							restrictions: account.restrictions
						});
					}
				});
			}

				// Check if there are linked accounts but none match the provided AccType and FIType
				if (global.isFlowChange !== 'true' && filteredAccounts.length === 0) {
					toast.error(t('paymentConsent.error.noRelevantAccLinked'));
					props.history.push(
						`/home/?number=${
							global.mobileNumber
						}&isAddAccount=${true}&isNewUser=${true}`
					);
					prevStep();
					return;
				}

				// Additional check for targeted discovery mode
				if (
					global.redirectAccountRestrictions &&
					!global.userClickedAddMore &&
					accountsToDisplay.length === 0
				) {
					toast.error(t('paymentConsent.error.noRelevantAccLinked'));
					props.history.push(
						`/home/?number=${
							global.mobileNumber
						}&isAddAccount=${true}&isNewUser=${true}`
					);
					return;
				}

				// Add isLinked flag and ensure linkRefNumber is present when isFlowChange is true
				let accountsWithLinkedFlag = filteredAccounts;
				let restrictedAccountsWithFlag = accountsToDisplay;

				if (global.isFlowChange === 'true') {
					// Mark API linked accounts with isLinked: true and proper linkRefNumber
					const linkedAccountsWithFlag = filteredAccounts.map((acc) => ({
						...acc,
						isLinked: true,
						linkRefNumber: acc.linkRefNumber || acc.RefNumber,
						fipName:
							acc.fipName ||
							t(
								`fips.${
									global.objectFormatFip?.[acc.fipId]?.fipId || acc.fipId
								}`
							),
					}));

					// Get discovered accounts from props
					const discoveredAccountsByFip =
						props?.location?.state?.discoveredAccounts || [];

					if (discoveredAccountsByFip.length > 0) {
						// Flatten discovered accounts and add fipId and fipName
						const flatDiscoveredAccounts = discoveredAccountsByFip.flatMap(
							(fipObj) =>
								fipObj.discoveredAccounts.map((acc) => ({
									...acc,
									fipId: fipObj.fipId,
									fipName: t(
										`fips.${
											global.objectFormatFip?.[fipObj.fipId]?.fipId ||
											fipObj.fipId
										}`
									),
								}))
						);

						// Filter out discovered accounts that are already linked
						const newDiscoveredAccounts = flatDiscoveredAccounts
							.filter(
								(discoveredAcc) =>
									!isAccountLinked(
										discoveredAcc,
										linkedAccountsWithFlag,
										discoveredAcc.fipId
									)
							)
							.map((acc) => ({ ...acc, isLinked: false }));

						// Merge linked and discovered accounts
						accountsWithLinkedFlag = [
							...linkedAccountsWithFlag,
							...newDiscoveredAccounts,
						];
					} else {
						accountsWithLinkedFlag = linkedAccountsWithFlag;
					}

					// Handle restrictedAccountsWithFlag similarly
					if (global.redirectAccountRestrictions) {
						restrictedAccountsWithFlag = filterLinkedAccountsByRestrictions(
							res?.LinkedAccounts
						).map((acc) => ({
							...acc,
							isLinked: true,
							linkRefNumber: acc.linkRefNumber || acc.RefNumber,
							fipName:
								acc.fipName ||
								t(
									`fips.${
										global.objectFormatFip?.[acc.fipId]?.fipId || acc.fipId
									}`
								),
						}));
					}
				}

				// Filter out restricted accounts from initial selection
				const accountsWithoutRestrictions = filterRestrictedAccounts(
					accountsToDisplay,
					consentsAll
				);

				// Initial selection for API flow
				const accountsForSelection = global.redirectAccountRestrictions
					? [...accountsToDisplay]
					: global.manualAccCheck
					? []
					: global?.accountRestrictions
					? []
					: [...accountsWithoutRestrictions];

				setState((prevState) => ({
					...prevState,
					allLinkedAccounts: filteredAccounts, // Unfiltered for validation
					matchedRestrictions, // Store only matched restrictions
					linkedAccounts: global.redirectAccountRestrictions
						? restrictedAccountsWithFlag
						: accountsWithLinkedFlag,
					selectedAccounts: accountsForSelection,
					consentDetailsList: consentsContext.consentList,
					consentSelectedAccounts: setConsentSelectedAccount(
						global.redirectAccountRestrictions ? accountsToDisplay : filteredAccounts
					),
				}));

				// Trigger analytics after accounts are loaded from API
				triggerConsentPageAnalytics(filteredAccounts);
			} else {
				// For isFlowChange, check if there are discovered accounts even if no linked accounts
				if (global.isFlowChange === 'true') {
					const discoveredAccountsByFip =
						props?.location?.state?.discoveredAccounts || [];

					if (discoveredAccountsByFip.length > 0) {
						// Process discovered accounts even without linked accounts
						const flatDiscoveredAccounts = discoveredAccountsByFip.flatMap(
							(fipObj) =>
								fipObj.discoveredAccounts.map((acc) => ({
									...acc,
									fipId: fipObj.fipId,
									fipName: t(
										`fips.${
											global.objectFormatFip?.[fipObj.fipId]?.fipId ||
											fipObj.fipId
										}`
									),
									isLinked: false,
								}))
						);

						// Filter by restrictions if needed
						const accountsToShow = global?.accountRestrictions
							? filterAccountsByRestrictions(flatDiscoveredAccounts)
							: flatDiscoveredAccounts;

						const consentSelections = setConsentSelectedAccount(accountsToShow);

						setState({
							...state,
							linkedAccounts: accountsToShow,
							selectedAccounts: [],
							consentDetailsList: consentsContext.consentList,
							consentSelectedAccounts: consentSelections,
						});

						props.updateLoader(false);
						triggerConsentPageAnalytics(accountsToShow);
						return;
					}
				}

				// No linked accounts and no discovered accounts (or not isFlowChange)
				props.updateLoader(false);
				if (global.sdkOptions?.toastMessageNoAccountLinked) {
					toast.error(t('paymentConsent.messages.toastMessageNoAccountLinked'));
				} else {
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
				}

				if (res?.status === 'RECORD-NOT-FOUND') {
					props.history.push(
						`/home/?number=${
							global.mobileNumber
						}&isAddAccount=${true}&isNewUser=${true}`
					);
					prevStep();
				} else {
					if (res?.status === 'FAILURE') {
						postMessage('session', 'FAILURE');
					} else if (res?.status === 'ERROR') {
						postMessage('session', 'ERROR');
					}

					setTimeout(() => {
						props.history.push({
							pathname: `/consent-status`,
							state: {
								statusCode: 20,
							},
						});
					}, 1000);
				}
			}
		});
	};

	const updateContext = (consentHandle, status) => {
		if (status === 'ACCEPT') {
			consentsAccepted.push(consentHandle);
			consentsContext.updateAcceptedConsentsMultiConsent(consentsAccepted);
		} else {
			consentsDenied.push(consentHandle);
			consentsContext.updateDeniedConsentsMultiConsent(consentsDenied);
		}
		consentsAll.push(consentsAll.shift());
		consentsContext.updateConsentList(consentsAll);
	};
	const consentApproveRequest = async (
		accounts,
		status,
		consentHandle,
		fiuID,
		isLast
	) => {
		setState({ ...state, isDisable: true });
		await authApis
			.consentApproveRequest(accounts, status, consentHandle, fiuID)
			.then((res) => {
				if (res && res?.status === 'SUCCESS') {
					const consentStatusText =
						status === 'ACCEPT'
							? t('paymentConsent.messages.consentApproved')
							: t('paymentConsent.messages.consentDenied');

					if (isLast) {
						setTimeout(() => {
							updateContext(consentHandle, status);
							toast.success(consentStatusText);
							props.history.push({
								pathname: `/consent-status`,
								state: {
									status: consentStatusText,
									statusCode: status === 'ACCEPT' ? 200 : 201,
								},
							});
						}, SUBMITTING_CONSENT_COUNTER);
					} else {
						setTimeout(() => {
							updateContext(consentHandle, status);
							toast.success(consentStatusText);
							setState({ ...state, isDisable: false });
						}, SUBMITTING_CONSENT_COUNTER);
					}
				} else {
					if (
						res?.code === undefined ||
						res?.code === null ||
						res?.code === ''
					) {
						toast.error(res?.message);
					} else {
						toast.error(t(`errors.code.${res.code}`));
					}
					if (res?.status === 'FAILURE') {
						postMessage('session', 'FAILURE');
					} else if (res?.status === 'ERROR') {
						postMessage('session', 'ERROR');
					}
					setTimeout(() => {
						props.history.push({
							pathname: `/consent-status`,
							state: {
								status: 'Consent denied',
								statusCode: 20,
							},
						});
					}, 500);
				}
			});
	};

	// Group non-linked accounts by FIP for sequential linking
	const groupNonLinkedAccountsByFip = () => {
		// Get all selected accounts from all consents
		const allSelectedAccounts = Object.values(
			state.consentSelectedAccounts
		).flat();

		// Remove duplicates using getUniqueKey function
		const seenAccounts = new Set();
		const uniqueAccounts = [];

		allSelectedAccounts.forEach((acc) => {
			const uniqueKey = getUniqueKey(acc, acc.fipId);
			if (!seenAccounts.has(uniqueKey)) {
				seenAccounts.add(uniqueKey);
				uniqueAccounts.push(acc);
			}
		});

		// Filter accounts that are not linked (when isFlowChange is true)
		// Only try to link accounts with isLinked === false (discovered, not matched)
		// Accounts with isLinked === true are already linked in backend
		const nonLinkedAccounts = uniqueAccounts.filter(
			(acc) => acc.isLinked === false
		);
		if (nonLinkedAccounts.length === 0) {
			return [];
		}

		// Group by FIP
		const groupedByFip = {};
		nonLinkedAccounts.forEach((acc) => {
			if (!groupedByFip[acc.fipId]) {
				groupedByFip[acc.fipId] = {
					fipId: acc.fipId,
					fipName:
						acc.fipName ||
						t(
							`fips.${global.objectFormatFip?.[acc.fipId]?.fipId || acc.fipId}`
						),
					fipLogo: global.objectFormatFip?.[acc.fipId]?.productIconUri,
					accounts: [],
				};
			}
			groupedByFip[acc.fipId].accounts.push(acc);
		});

		return Object.values(groupedByFip);
	};

	// Handle successful linking of accounts for a FIP
	const handleLinkSuccess = (linkedAccounts) => {
		// Update state to mark these accounts as linked and add linkRefNumber
		setState((prev) => {
			const updatedLinkedAccounts = prev.linkedAccounts.map((acc) => {
				// Use getUniqueKey for consistent stable/unstable FIP matching
				const accKey = getUniqueKey(acc, acc.fipId);
				const linked = linkedAccounts.find(
					(la) => getUniqueKey(la, la.fipId) === accKey
				);
				if (linked) {
					return {
						...acc,
						isLinked: true,
						linkRefNumber: linked.linkRefNumber,
						fipName: linked.fipName,
					};
				}
				return acc;
			});

			// Regenerate consentSelectedAccounts from updated linkedAccounts
			// This ensures object references match for the includes() check in updateAccounts
			const updatedConsentSelectedAccounts = {};
			Object.keys(prev.consentSelectedAccounts).forEach((consentHandle) => {
				const consent = consentsAll.find(
					(c) => c.ConsentHandle === consentHandle
				);
				if (consent) {
					const restrictions = computeAccountRestrictions(
						consent,
						updatedLinkedAccounts
					);
					const restrictedAccountRefs = Object.keys(restrictions);

					// Filter accounts that were previously selected
					const previouslySelectedKeys = new Set(
						prev.consentSelectedAccounts[consentHandle].map((acc) =>
							getUniqueKey(acc, acc.fipId)
						)
					);

					updatedConsentSelectedAccounts[consentHandle] =
						updatedLinkedAccounts.filter((acc) => {
							const accKey = getUniqueKey(acc, acc.fipId);
							return (
								previouslySelectedKeys.has(accKey) &&
								consent?.fiTypes.includes(acc?.FIType) &&
								!restrictedAccountRefs.includes(acc?.accRefNumber)
							);
						});
				}
			});

			// Also update selectedAccounts with same object references
			const previouslySelectedKeys = new Set(
				prev.selectedAccounts.map((acc) => getUniqueKey(acc, acc.fipId))
			);
			const updatedSelectedAccounts = updatedLinkedAccounts.filter((acc) =>
				previouslySelectedKeys.has(getUniqueKey(acc, acc.fipId))
			);

			return {
				...prev,
				linkedAccounts: updatedLinkedAccounts,
				consentSelectedAccounts: updatedConsentSelectedAccounts,
				selectedAccounts: updatedSelectedAccounts,
			};
		});

		// Move to next FIP or close dialog and proceed
		moveToNextFipOrProceed();
	};

	// Handle skip linking for current FIP
	const handleSkipLinking = () => {
		// Just move to next FIP without linking
		moveToNextFipOrProceed();
	};

	// Move to next FIP or proceed with consent if all done
	const moveToNextFipOrProceed = () => {
		setLinkingState((prevState) => {
			const nextIndex = prevState.currentFipIndex + 1;

			if (nextIndex < prevState.fipsToLink.length) {
				// Move to next FIP
				return {
					...prevState,
					currentFipIndex: nextIndex,
				};
			} else {
				// All FIPs processed (linked or skipped), close dialog
				// Set flag to trigger consent approval after state updates
				setShouldProceedWithConsent(true);

				return {
					isLinking: false,
					currentFipIndex: 0,
					fipsToLink: [],
					showLinkDialog: false,
				};
			}
		});
	};

	// Watch for flag to proceed with consent after linking is complete
	useEffect(() => {
		if (shouldProceedWithConsent) {
			setShouldProceedWithConsent(false);
			// Small delay to ensure all state updates have completed
			setTimeout(() => {
				proceedWithConsentApproval();
			}, 100);
		}
	}, [shouldProceedWithConsent]);

	// Handle cancel linking
	const handleCancelLinking = () => {
		setLinkingState({
			isLinking: false,
			currentFipIndex: 0,
			fipsToLink: [],
			showLinkDialog: false,
		});
	};

	// Proceed with consent approval after all accounts are linked
	const proceedWithConsentApproval = async () => {
		const consents = consentsContext?.selectedConsents;
		let continueApprove = true;
		const consentAccounts = [];

		// For isFlowChange, create a map from state.linkedAccounts for previously linked accounts
		let linkedAccountsMap = {};
		if (global.isFlowChange === 'true') {
			state.linkedAccounts.forEach((acc, index) => {
				const refNumber = acc.linkRefNumber || acc.RefNumber;
				// Only add to map if account actually has a reference number
				if (refNumber) {
					// Add to map using multiple keys for better matching
					// 1. Using accRefNumber (for stable FIPs)
					if (acc.accRefNumber) {
						linkedAccountsMap[acc.accRefNumber] = refNumber;
					}

					// 2. Using getUniqueKey (for both stable and unstable)
					const uniqueKey = getUniqueKey(acc, acc.fipId);
					linkedAccountsMap[uniqueKey] = refNumber;
				}
			});
		}

		for (let k = 0; k < consents?.length; k++) {
			let requiredAccountsSelected = [];
			const requiredFI = consents[k].fiTypes;
			// If user clicked "Add More", send user's actual selection
			// Otherwise, filter by restrictions in targeted mode
			const selectedAccounts = (global.redirectAccountRestrictions && !global.userClickedAddMore)
				? filterSelectedAccountsByRestrictions(
						state.consentSelectedAccounts[consents[k].ConsentHandle]
				  )
				: state.consentSelectedAccounts[consents[k].ConsentHandle] || [];
			let fips = selectedAccounts
				.filter((el) => requiredFI.includes(el?.FIType))
				.map((el) => el?.fipId);
			fips = [...new Set(fips)];
			for (let j = 0; j < fips?.length; j++) {
				let withFip = {
					FIP: {
						id: fips[j],
					},
					Accounts: [],
				};
				for (let i = 0; i < selectedAccounts?.length; i++) {
					if (requiredFI.includes(selectedAccounts[i]?.FIType)) {
						if (fips[j] === selectedAccounts[i]?.fipId) {
							let single = {
								accType: selectedAccounts[i]?.accType,
								accRefNumber: selectedAccounts[i]?.accRefNumber,
								maskedAccNumber: selectedAccounts[i]?.maskedAccNumber,
								FIType: selectedAccounts[i]?.FIType,
								fipId: selectedAccounts[i]?.fipId,
							};

							// Add linkRefNumber and fipName if available
							let linkRefNumber =
								selectedAccounts[i]?.linkRefNumber ||
								selectedAccounts[i]?.RefNumber;

							// For isFlowChange, if linkRefNumber not found, try to get from linkedAccountsMap
							if (global.isFlowChange === 'true' && !linkRefNumber) {
								// Try to get from linkedAccountsMap (previously linked accounts)
								// 1. Try accRefNumber first (most reliable for stable FIPs)
								if (selectedAccounts[i]?.accRefNumber) {
									linkRefNumber =
										linkedAccountsMap[selectedAccounts[i].accRefNumber];
								}

								// 2. If not found, try getUniqueKey
								if (!linkRefNumber) {
									const key = getUniqueKey(
										selectedAccounts[i],
										selectedAccounts[i]?.fipId
									);
									linkRefNumber = linkedAccountsMap[key];
								}

								if (!linkRefNumber) {
									// If account is already linked (isLinked: true), it's already in backend
									// Don't skip it, but don't require linkRefNumber
									if (selectedAccounts[i]?.isLinked === true) {
										// Don't add linkRefNumber, backend will match by accRefNumber
									} else {
										// Skip account without linkRefNumber (discovered but never linked)
										continue;
									}
								}
							}

							// Add linkRefNumber and fipName to payload if available
							if (linkRefNumber) {
								single.linkRefNumber = linkRefNumber;
							}

							// Add fipName - get from account or generate from translation
							const fipName =
								selectedAccounts[i]?.fipName ||
								t(
									`fips.${
										global.objectFormatFip?.[selectedAccounts[i]?.fipId]
											?.fipId || selectedAccounts[i]?.fipId
									}`
								);
							if (fipName) {
								single.fipName = fipName;
							}

							if (
								!isAccountLinked(
									single,
									withFip.Accounts,
									selectedAccounts[i]?.fipId
								)
							) {
								withFip.Accounts.push(single);
							}
						}
					}
				}
				if (withFip.Accounts.length > 0) {
					requiredAccountsSelected.push(withFip);
				}
			}
			if (requiredAccountsSelected.length === 0) {
				if (global.isFlowChange !== 'true') {
					toast.error(t('paymentConsent.error.noRelevantAccSelected'));
				}
				continueApprove = false;
			} else {
				consentAccounts.push({
					ConsentHandle: consents[k].ConsentHandle,
					fiuId: consents[k].FIU.id,
					Accounts: requiredAccountsSelected,
				});
			}
		}
		if (continueApprove) {
			setState({ ...state, isDisable: true, disableType: 'ACCEPT' });
			let isLast = false;
			for (let k = 0; k < consentAccounts?.length; k++) {
				if (k === consentAccounts?.length - 1) {
					isLast = true;
				}
				await consentApproveRequest(
					consentAccounts[k].Accounts,
					'ACCEPT',
					consentAccounts[k].ConsentHandle,
					consentAccounts[k].fiuId,
					isLast
				);
			}

			// Calculate total accounts across active consents only
			const totalAccounts = Object.entries(state.consentSelectedAccounts)
				.filter(([consentHandle]) =>
					selectedConsentsState.includes(consentHandle)
				)
				.flatMap(([_, accounts]) => accounts || []).length;

			// Calculate unique accounts from active consents only
			const uniqueAccounts = new Set(
				Object.entries(state.consentSelectedAccounts)
					.filter(([consentHandle]) =>
						selectedConsentsState.includes(consentHandle)
					)
					.flatMap(([_, accounts]) => accounts || [])
					.map((acc) => `${acc.maskedAccNumber}-${acc.FIType}-${acc.accType}`)
			).size;

			// Capture analytics for approved consents
			const metrics = {
				totalConsents: consentsAll.length,
				approvedConsents: consentsContext?.selectedConsents.length,
				uniqueAccounts,
				totalAccounts,
				fiTypes: Array.from(
					new Set(state.linkedAccounts.map((acc) => acc.FIType))
				),
				isPurposeIconClicked,
				isAccountInfoIconClicked,
			};
			captureConsentApproved(metrics);
		}
	};

	const handleAcceptFiuMultiple = async () => {
		const consents = consentsContext?.selectedConsents;
		if (consents && consents.length > 0) {
			if (global?.accountRestrictions?.maxAcc) {
				if (
					(state.selectedAccounts?.length || 0) >
					global?.accountRestrictions?.maxAcc
				) {
					toast.error(
						`${t('paymentConsent.messages.selectMax')} ${
							global?.accountRestrictions?.maxAcc
						} ${t('paymentConsent.messages.selectedConsent')}`
					);
					return;
				}
			}
			if (
				areAllArraysEmptyForConsents(
					state.consentSelectedAccounts,
					selectedConsentsState
				)
			) {
				toast.error(t('paymentConsent.error.selectAtleaseOne'));
				return;
		} else if (
			global.redirectAccountRestrictions &&
			!areAllMandatoryRestrictionsSatisfied(
				state.allLinkedAccounts,
				state.matchedRestrictions
			)
		) {
			toast.error(t('paymentConsent.error.linkMandatoryAccounts'));
			return;
			} else {
				// Check if isFlowChange and there are non-linked accounts
				if (global.isFlowChange === 'true') {
					const fipsToLink = groupNonLinkedAccountsByFip();
					if (fipsToLink.length > 0) {
						// Start linking process
						setLinkingState({
							isLinking: true,
							currentFipIndex: 0,
							fipsToLink,
							showLinkDialog: true,
						});
						return; // Wait for linking to complete
					}
				}

				// No non-linked accounts or not isFlowChange, proceed with consent approval
				await proceedWithConsentApproval();
			}
		} else {
			if (global?.institutionType === 'LSP') {
				setOpenDrawer(true);
			} else {
				toast.error(t('paymentConsent.error.noConsentSelected'));
			}
			return;
		}
	};

	const handleDeny = async () => {
		setState({ ...state, isDisable: true });
		let isLast =
			consentsAll.length - consentsAccepted.length - consentsDenied.length === 1
				? true
				: false;
		const consents = consentsContext.consentList;
		for (let k = 0; k < consents.length; k++) {
			if (k === consents.length - 1) {
				isLast = true;
			}
			await consentApproveRequest(
				[],
				'DENY',
				consents[k].ConsentHandle,
				consents[k].FIU.id,
				isLast
			);
		}

		// Calculate total accounts across active consents only
		const totalAccounts = Object.entries(state.consentSelectedAccounts)
			.filter(([consentHandle]) =>
				selectedConsentsState.includes(consentHandle)
			)
			.flatMap(([_, accounts]) => accounts).length;

		// Calculate unique accounts from active consents only
		const uniqueAccounts = new Set(
			Object.entries(state.consentSelectedAccounts)
				.filter(([consentHandle]) =>
					selectedConsentsState.includes(consentHandle)
				)
				.flatMap(([_, accounts]) => accounts)
				.map((acc) => `${acc.maskedAccNumber}-${acc.FIType}-${acc.accType}`)
		).size;

		// Capture analytics for denied consents
		const metrics = {
			totalConsents: consentsAll.length,
			deniedConsents: consentsAll.length,
			uniqueAccounts,
			totalAccounts,
			fiTypes: Array.from(
				new Set(state.linkedAccounts.map((acc) => acc.FIType))
			),
			isPurposeIconClicked,
			isAccountInfoIconClicked,
		};
		captureConsentDenied(metrics);

		consentsContext.updateConsentList([]);
	};
	//-----------------------------------
	const updateAccounts = (el, data) => {
		// Ensure data is an array
		const accountsArray = Array.isArray(data) ? data : [];

		if (accountsArray.includes(el)) {
			const index = accountsArray.indexOf(el);
			accountsArray.splice(index, 1);
		} else {
			accountsArray.push(el);
		}
		return accountsArray;
	};

	const selectUnselectAllFIAccounts = (el, name, consentHandle) => {
		// Get current consent-specific accounts
		const currentConsentAccounts = state.consentSelectedAccounts[consentHandle] || [];
		
		// Check if all accounts in el are already selected for this consent
		const allAccountsSelected = el.every(account => 
			currentConsentAccounts.some(selected => 
				selected.accRefNumber === account.accRefNumber && 
				selected.fipId === account.fipId
			)
		);
		let updatedSelectedAccounts;
		let updatedConsentAccounts;
		
		if (allAccountsSelected) {
			// Unselect all - remove accounts from both states
			updatedSelectedAccounts = state.selectedAccounts.filter(account => 
				!el.some(acc => 
					acc.accRefNumber === account.accRefNumber && 
					acc.fipId === account.fipId
				)
			);
			
			updatedConsentAccounts = currentConsentAccounts.filter(account => 
				!el.some(acc => 
					acc.accRefNumber === account.accRefNumber && 
					acc.fipId === account.fipId
				)
			);
		} else {
			// Select all - add accounts to both states (avoid duplicates)
			updatedSelectedAccounts = [...state.selectedAccounts];
			el.forEach(account => {
				if (!updatedSelectedAccounts.some(acc => 
					acc.accRefNumber === account.accRefNumber && 
					acc.fipId === account.fipId
				)) {
					updatedSelectedAccounts.push(account);
				}
			});
			
			updatedConsentAccounts = [...currentConsentAccounts];
			el.forEach(account => {
				if (!updatedConsentAccounts.some(acc => 
					acc.accRefNumber === account.accRefNumber && 
					acc.fipId === account.fipId
				)) {
					updatedConsentAccounts.push(account);
				}
			});
		}
		
		setState({
			...state,
			selectedAccounts: updatedSelectedAccounts,
			consentSelectedAccounts: {
				...state.consentSelectedAccounts,
				[consentHandle]: updatedConsentAccounts
			}
		});
	};

	const selectUnselectAcc = async (el, consentHandle = null) => {
		// Check if the account is restricted for the current consent
		const currentConsent = consentHandle
			? consentsAll.find((consent) => consent.ConsentHandle === consentHandle)
			: null;

		if (currentConsent && isAccountRestrictedForConsent(el, currentConsent)) {
			// Account is restricted, don't allow selection
			return;
		}

		let data = updateAccounts(el, [...state.selectedAccounts]);
		if (consentHandle) {
			// Ensure consentSelectedAccounts[consentHandle] exists and is an array
			const currentConsentAccounts =
				state.consentSelectedAccounts[consentHandle] || [];
			const consentData = updateAccounts(el, [...currentConsentAccounts]);
			const accounts = { ...state.consentSelectedAccounts };
			accounts[consentHandle] = consentData;
			setState({
				...state,
				selectedAccounts: data,
				consentSelectedAccounts: accounts,
			});
			return;
		}
		setState({ ...state, selectedAccounts: data });
	};
	//-------------------------------------------------------
	//Floating Button logic
	const [unviewedConsents, setUnviewedConsents] = useState(
		consentsAll.length - 1
	);
	const consentListRef = useRef();

	useEffect(() => {
		const lastChildren = [
			...document.getElementsByClassName('lastChildCard'),
		].slice(1);
		const observer = new IntersectionObserver((entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					setUnviewedConsents((prev) => prev - 1);
				}
			}
		});
		for (const child of lastChildren) {
			observer.observe(child);
		}

		return () => {};
	}, []);

	const handleMoreConsentsClick = () => {
		const consentListElement = consentListRef.current;
		if (!consentListElement) return;

		const nextConsentIndex = consentsAll.length - unviewedConsents;
		const nextConsentElement = consentListElement.children[nextConsentIndex];
		nextConsentElement.scrollIntoView({ behavior: 'smooth' });
		nextConsentElement.focus();
	};

	// Effect to automatically unselect restricted accounts
	useEffect(() => {
		const { selectedAccounts, consentSelectedAccounts } =
			removeRestrictedAccountsFromSelection(
				state.selectedAccounts,
				state.consentSelectedAccounts,
				consentsAll,
				state.linkedAccounts
			);

		// Update state if changes were made
		if (
			selectedAccounts.length !== state.selectedAccounts.length ||
			JSON.stringify(consentSelectedAccounts) !==
				JSON.stringify(state.consentSelectedAccounts)
		) {
			setState((prevState) => ({
				...prevState,
				selectedAccounts,
				consentSelectedAccounts,
			}));
		}
	}, [state.linkedAccounts, consentsAll]);

	const toggleSelectAll = () => {
		if (selectedConsentsState?.length < consentsAll.length) {
			setSelectedConsentsState(
				consentsAll.map((a) => {
					return a?.ConsentHandle;
				})
			);
			consentsContext.updateSelectedConsentList(consentsAll.map((a) => a));
			setSelectAll(true);
		} else {
			// un select all for FIU getting consentoptions from config
			if (global.consentOptions) {
				let updatedConsents = [];
				for (const option of global.consentOptions) {
					for (const consent of consentsAll) {
						if (
							option['Purpose.code'] == consent?.Purpose?.code &&
							!option.checkbox
						) {
							consentsContext.updateSelectedConsentList(
								consentsAll.filter((consent) =>
									consentsAll.includes(consent?.ConsentHandle)
								)
							);
							updatedConsents.push(consent.ConsentHandle);
						}
					}
				}
				// Update state once after the loops
				setSelectedConsentsState(updatedConsents);
				setSelectAll(false);
			} else {
				consentsContext.updateSelectedConsentList([]);
				setSelectedConsentsState([]);
				setSelectAll(false);
			}
		}
	};
	const isDarkTheme = props.customDetails?.darkTheme === true;
	useEffect(() => {
		if (props?.updateInitialLoader) {
			props.updateInitialLoader(false);
		}
	}, []);
	return (
		<Box
			sx={{
				fontFamily: props?.customDetails?.fontFamily,
				display: 'flex',
				justifyContent: { xs: 'start', md: 'center' },
				flexDirection: { xs: 'column', md: 'column' },
				minHeight: { xs: 'auto', md: 'auto' },
				alignItems: 'start',
				m: `${!mobileScreen ? '0 3rem' : 'none'}`,
			}}
		>
			<RequestedConsents
				display={'flex'}
				customDetails={props.customDetails}
				consentDetailsList={state?.consentDetailsList}
				selectedConsentsState={selectedConsentsState}
				handleIsActive={selectUnselectConsents}
				selectAll={selectAll}
				toggleSelectAll={toggleSelectAll}
				showSelectAll={showSelectAll}
				{...props}
			/>
			<div
				ref={consentListRef}
				style={{
					display: 'flex',
					flexDirection: 'column',
					// gap: '1rem',
					width: '100%',
				}}
			>
				{consentsAll.map((consent, idx) => (
					<ConsentCardFull
						key={idx}
						customDetails={props.customDetails}
						consentDetails={consent}
						id={idx + 1}
						selectedConsentsState={selectedConsentsState}
						handleIsActive={selectUnselectConsents}
						isMultiConsent={consentsAll?.length > 1}
						isLast={idx === consentsAll.length - 1}
						onInfoClick={handleInfoClick}
					>
						<LinkedAccountsSection
							handleSelect={selectUnselectAcc}
							superState={state}
							selectedConsentsState={selectedConsentsState}
							linkedAccounts={state.uniqueLinkedAccounts}
							customDetails={props.customDetails}
							consentDetails={
								state?.consentDetailsList || global.selectedConsent
							}
							consentHandle={consent?.ConsentHandle}
							selectedAccounts={state.selectedAccounts}
							handleAccept={handleAcceptFiuMultiple}
							handleDeny={handleDeny}
							consent={consent}
							selectUnselectAllFIAccounts={selectUnselectAllFIAccounts}
							{...props}
							accountRestrictions={computeAccountRestrictions(
								consent,
								state.linkedAccounts
							)}
						/>
					</ConsentCardFull>
				))}
				<FloatingButton
					numberOfUnviewedConsents={unviewedConsents}
					handleClick={handleMoreConsentsClick}
				/>
				<div>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							width: '100%',
						}}
					>
						<Box
							sx={{
								bottom: mobileScreen ? '0rem' : '1.875rem',
								right: mobileScreen ? '0rem' : '0rem',
								backgroundColor: mobileScreen
									? theme.palette.background.paper
									: 'none',
								gap: mobileScreen ? '1rem' : '1.25rem',
								width: mobileScreen
									? '100vw'
									: global.alternativeText?.DENY_BTN
									? '40%'
									: '20%',
								marginRight: mobileScreen ? 0 : '40px !important',
								flexWrap: 'wrap',
								...linkedAccountsSectionStyles.buttonGroup,
							}}
						>
							<Button
								variant="outlined"
								fullWidth={mobileScreen}
								color="error"
								onClick={() => setDeny(true)}
								sx={{
									flex: 1,
									// Override the global button styles for Deny button
									backgroundColor: isDarkTheme
										? 'transparent !important'
										: '#ffffff !important',
									color: '#E94B4B !important',
									borderColor: '#E94B4B !important',
									'&:hover': {
										backgroundColor: 'rgba(233, 75, 75, 0.04) !important',
										borderColor: '#E94B4B !important',
									},
								}}
							>
								{t('common.buttons.deny')}
							</Button>
							<Button
								variant="contained"
								fullWidth={mobileScreen}
								disabled={unviewedConsents > 0}
								onClick={() => {
									handleAcceptFiuMultiple();
								}}
								sx={{
									backgroundColor:
										global.sdkOptions?.isAcceptDisabled === 'true' &&
										isAcceptDisabled
											? '#e0e0e0'
											: `${
													props.customDetails?.ctaBackgroundColor ??
													props.customDetails?.primaryColor
											  } !important`,
									color:
										global.sdkOptions?.isAcceptDisabled === 'true' &&
										isAcceptDisabled
											? '#666666'
											: `${
													props.customDetails?.ctaTextColor ||
													(isDarkTheme ? '#000000' : '#FFFFFF')
											  } !important`,
									flex: 1,
									border: `1px solid ${
										global.sdkOptions?.isAcceptDisabled === 'true' &&
										isAcceptDisabled
											? '#cccccc'
											: props?.customDetails?.ctaBorderColor ??
											  props?.customDetails?.primaryColor
									}`,
									'&:hover': {
										backgroundColor:
											global.sdkOptions?.isAcceptDisabled === 'true' &&
											isAcceptDisabled
												? '#e0e0e0'
												: `${
														props.customDetails?.ctaHoverPrimaryColor ??
														props.customDetails?.primaryColor
												  } !important`,
									},
								}}
							>
								{t('common.buttons.accept')}
							</Button>
							{mobileScreen ? <WhyShare {...props} /> : null}
						</Box>
					</Box>
				</div>
			</div>
			<DialogBox
				open={deny}
				handleClose={handleClose}
				title={t('paymentConsent.dialog.denyConsent.title')}
				subTitle={t('paymentConsent.dialog.denyConsent.subtitle')}
				boxPadding="1.5rem"
				subTitleMaxWidth="85%"
			>
				<DenyConsent
					handleCancel={() => setDeny(false)}
					{...props}
					handleDeny={handleDeny}
					isDarkTheme={isDarkTheme}
				/>
			</DialogBox>
			<Drawer
				open={openDrawer}
				setOpen={setOpenDrawer}
				medWidth={0}
				closeBtnTop={'1rem'}
				customDetails={props?.customDetails}
			>
				<FiuList
					selectUnselectConsents={selectUnselectConsents}
					handleAccept={handleAcceptFiuMultiple}
					selectedConsentsState={selectedConsentsState}
					linkedAccountsSelected={state.consentSelectedAccounts}
				/>
			</Drawer>
			{!mobileScreen && (
				<Box sx={{ m: '1rem auto' }}>
					<WhyShare {...props} />
				</Box>
			)}

			{/* Link Accounts OTP Modal/Drawer */}
			{linkingState.showLinkDialog &&
				linkingState.fipsToLink.length > 0 &&
				linkingState.fipsToLink[linkingState.currentFipIndex] && (
					<>
						{/* Desktop Modal */}
						{!mobileScreen && (
							<Dialog
								open={linkingState.showLinkDialog}
								onClose={() => {}}
								maxWidth="sm"
								PaperProps={{
									sx: {
										borderRadius: '12px',
										backgroundColor: isDarkTheme ? '#161616' : '#FFFFFF',
									},
								}}
							>
								<LinkAccountsOtp
									key={`fip-${linkingState.currentFipIndex}-${
										linkingState.fipsToLink[linkingState.currentFipIndex].fipId
									}`}
									fipId={
										linkingState.fipsToLink[linkingState.currentFipIndex].fipId
									}
									fipName={
										linkingState.fipsToLink[linkingState.currentFipIndex]
											.fipName
									}
									fipLogo={
										linkingState.fipsToLink[linkingState.currentFipIndex]
											.fipLogo
									}
									accounts={
										linkingState.fipsToLink[linkingState.currentFipIndex]
											.accounts
									}
									onLinkSuccess={handleLinkSuccess}
									onSkip={handleSkipLinking}
									onCancel={handleCancelLinking}
									authApis={authApis}
									customDetails={props.customDetails}
								/>
							</Dialog>
						)}

						{/* Mobile Drawer */}
						{mobileScreen && (
							<Drawer
								open={linkingState.showLinkDialog}
								setOpen={(isOpen) => {
									if (!isOpen) {
										handleCancelLinking();
									}
								}}
								customDetails={props?.customDetails}
								showCloseBtn={false}
							>
								<LinkAccountsOtp
									key={`fip-${linkingState.currentFipIndex}-${
										linkingState.fipsToLink[linkingState.currentFipIndex].fipId
									}`}
									fipId={
										linkingState.fipsToLink[linkingState.currentFipIndex].fipId
									}
									fipName={
										linkingState.fipsToLink[linkingState.currentFipIndex]
											.fipName
									}
									fipLogo={
										linkingState.fipsToLink[linkingState.currentFipIndex]
											.fipLogo
									}
									accounts={
										linkingState.fipsToLink[linkingState.currentFipIndex]
											.accounts
									}
									onLinkSuccess={handleLinkSuccess}
									onSkip={handleSkipLinking}
									onCancel={handleCancelLinking}
									authApis={authApis}
									customDetails={props.customDetails}
								/>
							</Drawer>
						)}
					</>
				)}
		</Box>
	);
}

export default PaymentConsent;
